import ElementDescription from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Shared/Helpers/ElementDescription';
import type InterviewView from '@UI/Store/Interviews/Views/InterviewView';

/** An interview or a dictated note: its own name when it has one, otherwise its kind and date. */
const describeInterview = (interview: InterviewView): ElementDescription => {
	const dateDisplay = interview.conductedOn?.toDisplay() ?? null;
	const trimmedName = interview.name?.trim() ?? '';
	const kindLabel = interview.kind.label;
	const fallbackTitle = dateDisplay !== null ? `${kindLabel} du ${dateDisplay}` : kindLabel;

	return new ElementDescription(
		trimmedName !== '' ? trimmedName : fallbackTitle,
		dateDisplay !== null ? `${kindLabel} · ${dateDisplay}` : kindLabel,
	);
};

export default describeInterview;
